export const resolveApiBaseUrl = ({
  apiUrl = process.env.REACT_APP_API_URL,
  environment = process.env.REACT_APP_ENV || process.env.NODE_ENV,
} = {}) => {
  const configuredUrl = String(apiUrl || '').trim();
  if (configuredUrl) return configuredUrl;

  if (environment === 'development' || environment === 'test') {
    return 'http://localhost:5000';
  }

  throw new Error('REACT_APP_API_URL is required for the ' + (environment || 'current') + ' environment.');
};

export const API_BASE_URL = resolveApiBaseUrl();

export const getAuthToken = () => localStorage.getItem('authToken');

export const setAuthSession = ({ token, user }) => {
  if (token) {
    localStorage.setItem('authToken', token);
  }

  if (user) {
    localStorage.setItem('currentUser', JSON.stringify(user));
  }
};

export const clearAuthSession = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('currentUser');
};

export const apiFetch = async (path, options = {}) => {
  const token = getAuthToken();
  const headers = {
    ...(options.body ? { 'Content-Type': 'application/json' } : {}),
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    clearAuthSession();
    window.dispatchEvent(new CustomEvent('sas-erp-auth-expired'));
  }

  return response;
};

export const parseApiResponse = async (response) => {
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    const validationMessages = [...(body.errors || []), ...(body.warnings || [])].map((item) => item?.message).filter(Boolean);
    const validationHint = body.canGenerate && body.warnings?.length ? 'Cochez la confirmation des avertissements pour poursuivre.' : '';
    const structuredError = body.error && typeof body.error === 'object' ? body.error : null;
    const message = validationMessages.length
      ? `${validationMessages.join(' · ')}${validationHint ? ` ${validationHint}` : ''}`
      : structuredError?.message || body.error || `HTTP error! status: ${response.status}`;
    const error = new Error(message);
    error.status = response.status;
    error.body = body;
    error.validation = body.errors || body.warnings ? body : null;
    throw error;
  }

  return body;
};
